function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from "react";
import { generateCloudinaryRawUrl } from "services/community/cloudinary-service";
import classnames from "classnames";
import { StyledLottieComponent } from "./lottie-component.scss";
class LottieComponent extends PureComponent {
    componentDidMount() {
        var _this = this;
        return _async_to_generator(function*() {
            _this._mounted = true;
            try {
                const lottieWeb = (yield import("lottie-web")).default;
                if (!_this._mounted) return;
                const { jsonPath, loop, autoplay, fireActionOnFrame } = _this.props;
                _this.animtaion = lottieWeb.loadAnimation({
                    container: _this._lottieDiv,
                    renderer: "svg",
                    loop,
                    autoplay,
                    path: generateCloudinaryRawUrl(jsonPath)
                });
                const { frame, action } = fireActionOnFrame;
                if (frame && action) {
                    _this.animtaion.onEnterFrame = _this.fireActionIfReachedFrame;
                }
            } catch (e) {
            // lottie-web failed to load — degrade gracefully
            }
        })();
    }
    componentWillUnmount() {
        this._mounted = false;
        if (this.animtaion) {
            this.animtaion.onEnterFrame = null;
        }
    }
    componentDidUpdate() {
        if (!this.animtaion) return;
        const { shouldPlay, reverseAnimation, shouldPause } = this.props;
        const animationDirection = reverseAnimation ? -1 : 1;
        this.animtaion.setDirection(animationDirection);
        shouldPlay && this.animtaion.play();
        shouldPause && this.animtaion.pause();
    }
    fireActionIfReachedFrame({ currentTime }) {
        const { reverseAnimation, fireActionOnFrame } = this.props;
        const { frame, action } = fireActionOnFrame;
        if (currentTime > frame && !reverseAnimation) {
            action();
        }
    }
    render() {
        const { aboveTheFold } = this.props;
        return /*#__PURE__*/ _jsx(StyledLottieComponent, {
            ref: (lottieDiv)=>this._lottieDiv = lottieDiv,
            className: classnames("lottie-component", {
                "above-the-fold": aboveTheFold
            })
        });
    }
    constructor(props){
        super(props);
        this.fireActionIfReachedFrame = this.fireActionIfReachedFrame.bind(this);
    }
}
export { LottieComponent as default };
LottieComponent.defaultProps = {
    jsonPath: "/static/lottie/arrow-swirl-down.json",
    autoplay: false,
    loop: false,
    fireActionOnFrame: {}
};
